import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppProvider } from "./context/AppContext";
import HomePage from "./pages/HomePage";
import IdCheckPage from "./pages/IdCheckPage";
import ResultPage from "./pages/ResultPage";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";

// Créer une instance QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Route d'accueil - gère l'initialisation */}
              <Route path="/" element={<HomePage />} />

              {/* Route de vérification d'identité - protégée par exid */}
              <Route
                path="/idcheck"
                element={
                  <ProtectedRoute requiredData="exid">
                    <IdCheckPage />
                  </ProtectedRoute>
                }
              />

              {/* Route de résultat - protégée par exid et timestamp */}
              <Route
                path="/result"
                element={
                  <ProtectedRoute requiredData="both">
                    <ResultPage />
                  </ProtectedRoute>
                }
              />

              {/* Route par défaut - redirige vers l'accueil */}
              <Route path="*" element={<HomePage />} />
            </Routes>
          </div>
        </Router>
      </AppProvider>
    </QueryClientProvider>
  );
};

export default App;
